import { render, staticRenderFns } from "./brandDetection.vue?vue&type=template&id=33ea1d7e&scoped=true&"
import script from "./brandDetection.vue?vue&type=script&lang=ts&"
export * from "./brandDetection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ea1d7e",
  null
  
)

export default component.exports